import { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@/components/primitives/Button.jsx';
import Card from '@/components/primitives/Card.jsx';
import Input from '@/components/primitives/Input.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import { getAuthSession, updateOwnProfile } from '@/redux/requests/sessionRequests.js';
import { authSessionUser } from '@/redux/selectors/userSelectors.js';

const MAX_NAME_LENGTH = 256;

/** The signed-in person's name, which they can change, and the email they sign in with. */
const ProfileSection = () => {
  const user = useSelector(authSessionUser);
  const savedName = user?.name || '';
  const [name, setName] = useState(savedName);
  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const trimmedName = name.trim();
  const isUnchanged = trimmedName === savedName.trim();

  const save = async (event) => {
    event.preventDefault();
    if (!trimmedName) {
      setError('Enter a name.');
      return;
    }
    setIsSaving(true);
    setError('');
    const res = await updateOwnProfile({ name: trimmedName });
    if (res?.success === false) {
      setIsSaving(false);
      setError(res.message || 'Your name was not saved. Try again.');
      return;
    }
    await getAuthSession();
    setName(trimmedName);
    setIsSaving(false);
    toastManager.add({ title: 'Name saved', description: 'Your teammates now see this name.', type: 'success' });
  };

  return (
    <Card title="Profile" description="How your teammates see you in Pieve.">
      <form className="settings-profile" onSubmit={save}>
        <div className="settings-field settings-field--wide">
          <Input label="Name" name="name" autoComplete="name" maxLength={MAX_NAME_LENGTH} value={name} onChange={(event) => setName(event.target.value)} error={error || undefined} />
        </div>
        <div className="settings-field settings-field--wide">
          <Input label="Email" name="email" type="email" value={user?.email || ''} readOnly hint="You sign in with this email. It cannot be changed here." />
        </div>
        <div>
          <Button type="submit" variant="primary" loading={isSaving} disabled={isUnchanged || !trimmedName}>
            Save name
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default ProfileSection;
